import { useEffect, useMemo } from 'react';
import DOMPurify from 'dompurify';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Message } from '@chatscope/chat-ui-kit-react';
import Notification from '../Notification';

function FormattedMessage({ message, chatContext }) {
  const history = useHistory();

  useEffect(() => {
    const handler = e => {
      if (e.target.classList.contains('case-link')) {
        e.preventDefault();
        const id = e.target.dataset.id;
        const slug = e.target.dataset.slug;
        history.push(`/workflow/${slug}/${id}`);
      }
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [history, message]);

  const sanitizedHTML = useMemo(
    () => ({
      __html: DOMPurify.sanitize(processMarkdownAndHtml(message, chatContext?.identifierCases)),
    }),
    [message, chatContext?.identifierCases]
  );

  return (
    <Message
      model={message}
      className={message.error ? 'is-error' : `${message.isFirst ? 'is-first' : ''} ${message.isContinuation ? 'is-continuation' : 'is-turn-start'}`}
    >
      <Message.CustomContent>
        <div className="markdown-content" style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={sanitizedHTML} />
      </Message.CustomContent>
    </Message>
  );
}

const processMarkdownAndHtml = (model, identifierCases = []) => {
  const processedContent = model.message.replace(/\n/g, '<br />');

  const htmlContent = processedContent
    .replace(/###\s?(.*?)(<br \/>|$ )/g, '<strong>$1</strong><br>')
    .replace(/##\s?(.*?)(\n|$)/g, '<h2>$1</h2>')
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.*?)\*/g, '<em>$1</em>')
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    .replace(/(\d{2}FF-\d{6}-[A-Z]{2})/g, match => {
      const uweEntity = identifierCases.find(c => c.number === match);
      return uweEntity ? `<a href="#" data-id="${uweEntity.id}" data-slug="${uweEntity.slug}" class="case-link">${match}</a>` : match;
    });

  return htmlContent;
};

export default FormattedMessage;
